import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetAccountByID } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";

const ViewAccount = () => {
  const navigate = useNavigate();
  let param = useParams();
  const acc_id = param.Account_id;
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: "Select Type",
    balance: "0",
    notes: "",
  });

  // const ActsGrid = [
  //   {
  //     field: "note",
  //     headerText: "Ledger Note",
  //     minWidth: "360",
  //     width: "440",
  //     maxWidth: "650",
  //     textAlign: "left",
  //   },
  //   {
  //     field: "datetime",
  //     headerText: "DateTime",
  //     minWidth: "180",
  //     width: "180",
  //     maxWidth: "240",
  //     textAlign: "center",
  //   },
  //   {
  //     field: "credit",
  //     headerText: "Credit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "debit",
  //     headerText: "Debit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "bal",
  //     headerText: "Balance",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  // ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Account");
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (acc_id) {
        await GetAccountByID(acc_id)
          .then((resp) => {
            setFormData({
              name: resp.data.name || "",
              description: resp.data.description || "",
              type: resp.data.type
                ? { label: resp.data.type, value: resp.data.type_id }
                : "Select Type",
              balance: resp.data.balance || "0",
              notes: resp.data.notes,
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [acc_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW ACCOUNT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Account Title:"
                  name="name"
                  value={formData.name}
                  placeholder="Account Title"
                  disabled
                />
                <TextInputField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  placeholder="Description"
                  disabled
                />
                <SelectField
                  label="Account Type:"
                  name="type"
                  value={formData.type}
                  placeholder="Account Type"
                  isDisabled
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  placeholder="Opening Balance"
                  disabled
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  placeholder="Notes"
                  disabled
                />
              </div>
            </Col>
          </Row>
          {/* <label className="label">Last 50 Ledgers: </label>
          {promiseInProgress ? (
            <LoadingIndicator />
          ) : (
            <GridComponent
              className="custom-grid1"
              dataSource={CustLedgs}
              pageSettings={{ pageSize: 60 }}
              allowSorting
              allowResizing
              toolbar={["Search"]}
              rowHeight={18}
            >
              <ColumnsDirective>
                {ActsGrid.map((item, index) => (
                  <ColumnDirective key={index} {...item} />
                ))}
              </ColumnsDirective>
              <Inject services={[Resize, Toolbar, Selection, Sort, Filter]} />
            </GridComponent>
          )} */}
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewAccount;
